export const DATA = {
    GET_ORDER_TEMPLATES: 'getOrderTemplates',
    SAVE_ORDER_TEMPLATES: 'saveOrderTemplates',
    DELETE_TEMPLATE: 'deleteTemplate',
    GET_TIENDANUBE_TOKEN: 'getTiendaNubeToken',
    GET_TIENDANUBE_ORDERS: 'getTiendaNubeOrders',
    GET_TIENDANUBE_CUSTOM_CARRIERS: 'getTiendaNubeCustomCarriers',
    IMPORT_TIENDANUBE: 'getTiendaNubeOrders',
    GET_DISPOSITIVOS: 'dispositivos',
};

export const BASE_URL = process.env['NX_CHAMELEON_URL'] || '/';

export const CHAMELEON_PATH = 'chameleon/chameleon_ajax.php';
